import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { JobType } from '@src/types/JobType'

interface Options {
  srrId: number | string,
  serialId: number,
  jobType: JobType,
  productId: number | string,
}

export const apiSrrMaterialProductRemove = (options: Options) => {
  const { 
    srrId, 
    serialId,
    jobType,
    productId,
  } = options

  const asOrSs = jobType === JobType.Asphalt ? 'asphalt' : 'sprayseal'
  const axOptions = {
    method: 'DELETE',
    url: `${BASE_API_URL}/v2/srr/${srrId}/material/${asOrSs}/details/${productId}`,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}